<template>
  <div v-if="ordersOpened">
    <v-badge inline color="red" :content="ordersOpened">{{ text }}</v-badge>
  </div>
  <div v-else>
    {{ text }}
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Badge',

  components: {},

  props: {
    text: {
      type: String,
      required: true
    }},

  data: () => ({}),

  computed: {
    ...mapState('orders_opened', ['ordersOpened'])
  },
  mounted() {
    this.getActualQuantityOpenedOrders();
  },

  created() {
    this.getQuantityOpenedOrders();
  },

  methods: {
    ...mapActions('orders_opened', [
      'getActualQuantityOpenedOrders',
      'getQuantityOpenedOrders'
    ])
  }
};
</script>
